"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateStatus = void 0;
var _constants = require("../constants");
/**
 * Default value for `validateStatus` option to prevent Axios from throwing non-5xx errors.
 */
const validateStatus = status => status >= _constants.STATUS_OK && status < _constants.STATUS_INTERNAL_SERVER_ERROR;
exports.validateStatus = validateStatus;
//# sourceMappingURL=validateStatus.js.map